// new every hour
const useCacheBuster = `${Math.ceil(new Date().getTime() / (1000 * 60 * 60))}`;

/**
 * Use the same cachebuster on several urls for same pageload,
 * so that the same image is loaded only once. Also tell server to drop
 * the cache-control: no-cache response header.
 */
export const optimizeImageUrl = (_url: string) => {
  if (!_url) return _url;

  if (!_url.startsWith("https://secure.webtemp.no/cgi-win")) {
    return _url;
  }

  const url = new URL(_url);
  if (url.searchParams.has("cacheBuster")) {
    url.searchParams.set("cacheBuster", useCacheBuster);
  }
  if (url.searchParams.has("cachebuster")) {
    url.searchParams.set("cachebuster", useCacheBuster);
  }

  url.searchParams.set("allow-cache", "1");

  return url.toString();
};
